'use strict';

exports.__esModule = true;
exports.default = set;

var _markAsDirty = require('./markAsDirty');

function set(currentValue, originalPath, value) {
  var start = (0, _markAsDirty.dirty)(currentValue);
  var path = (0, _markAsDirty.normalizePath)(originalPath);
  var parts = path.split('.');
  if (!parts.length) {
    return value;
  }
  var propName = parts.pop();
  if (!propName) {
    throw new Error('Path is not complete');
  }

  var current = start;
  for (var i = 0; i < parts.length; i += 1) {
    var key = parts[i];
    if (!key) {
      throw new Error('Path is not complete');
    }

    current[key] = (0, _markAsDirty.dirty)(current[key]);

    current = current[key];
  }

  current[propName] = value;

  return start;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/utils/set.js
 ** module id = 1286
 ** module chunks = 0
 **/